import { ComponentType, useMemo, useState } from 'react';
import clsx from 'clsx';
import useBuildingList from 'api/hooks/use-building-list';
import Tab from 'components/tab';
import TextInput from '../../../../components/text-input';
import StreetTab from '../street-tab/StreetTab';
import styles from './styles.module.scss';

export type TabsProps = {
  houseId: number | undefined;
  setHouseId: React.Dispatch<React.SetStateAction<number | undefined>>;
  setFacilityCount: React.Dispatch<React.SetStateAction<number | undefined>>;
  footer?: ComponentType;
};

export const Tabs: React.FC<TabsProps> = (props) => {
  const tabs = [
    { key: '#address', title: 'По адресу' },
    { key: '', title: '' },
  ];
  const { setHouseId, houseId, setFacilityCount } = props;
  const [query, setQuery] = useState('');
  const { buildings, isLoading } = useBuildingList(query);

  interface TransformedData {
    address: string;
    id: number;
    facilityCount: number;
  }

  const transformedData = useMemo(() => {
    return buildings.reduce<TransformedData[]>((acc, street) => {
      street.buildings.forEach((building: any) => {
        acc.push({
          address: `${street?.streetName} ${building?.house}`,
          id: building.id,
          facilityCount: building.facilityCount,
        });
      });
      return acc;
    }, []);
  }, [buildings]);

  return (
    <>
      <div className={clsx(styles.tabsSecondary, styles.tabs)}>
        {tabs.map((item) => (
          <Tab
            key={item.key}
            onClick={() => {}}
            title={item.title}
            selected={'#address' === item?.key}
          />
        ))}
      </div>

      <div className={styles.paddedContent}>
        <>
          <StreetTab
            changeFacilityCount={() => {}}
            buildings={transformedData}
            isLoading={isLoading}
            setHouseId={setHouseId}
            setFacilityCount={setFacilityCount}
            houseId={houseId}
            footer={props.footer}
          />

          <TextInput
            tall
            value={query}
            onChange={setQuery}
            placeholder='Введите улицу'
            className={styles.mapSearchInput}
          />
        </>
      </div>
    </>
  );
};
